import { CanMatchFn, Route, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@app/core/services/auth/auth.service';
import { AuthNavigationService } from '@domains/auth/auth-navigation.service';
import { ToastService } from '@shared/components/toast';
import { Role } from '@shared/enums/role.enum';
import { PortalTypes } from '@shared/enums';
import { firstValueFrom } from 'rxjs';

export const authGuard: CanMatchFn = async (route: Route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toast = inject(ToastService);
  const authNavigationService = inject(AuthNavigationService);

  const isAuthenticated = await firstValueFrom(authService.verifyAuth());

  const currentRoles = authService.roles();
  const isAdmin = currentRoles.includes(Role.Clerk);

  if (!isAuthenticated) {
    router.navigateByUrl('/start/access');
    return false;
  }

  const requiredRoles: Role | undefined = route.data?.['roles'];

  const isAdminAllowed = requiredRoles?.includes(Role.Clerk);
  const isSubscriberAllowed = requiredRoles?.includes(Role.Subscriber);

  if (isAdminAllowed && !isAdmin) {
    showNoPermissionToast(toast);
    authNavigationService.goToAccessPage({ portalType: PortalTypes.CLERK });
    return false;
  } else if (isSubscriberAllowed && !isAdminAllowed && isAdmin) {
    showNoPermissionToast(toast);
    authNavigationService.goToAccessPage({ portalType: PortalTypes.PUBLIC });
    return false;
  }

  return true;
};

function showNoPermissionToast(toast: ToastService) {
  toast.show({
    message: "You don't have permission to access this page.",
    type: 'error',
  });
}
